import { axios } from '@/utils/request'

const api = {
  getCapitalList: '/5cb1cca8f1235',
  getCapitalLog: '/5ccbdac74aa62',
  getAllToBeReviewedList:'/62a04722952d7',
  delFromAllToBeReviewedList:'/62a04904d2f95',
  getDrawMoneyStatus:'/62a978fdeb2da'

}

export default {
  // 获取提现列表
  getCapitalList: parameter => {
    const params = Object.assign(parameter, {
      page: parameter.pageNo || 1,
      size: parameter.pageSize || 20
    })
    return axios({
      url: api.getCapitalList,
      method: 'get',
      params: params
    }).then(res => {
      return {
        data: res.data.list || [],
        pageNo: parameter.pageNo,
        pageSize: parameter.pageSize,
        totalCount: res.data.count,
        finished: res.data.finished || 0,
        need_operate: res.data.need_operate || 0,
        need_operate_sum: res.data.need_operate_sum || 0,
        total_number: res.data.total_number || 0
      }
    })
  },
  // 获取财产日志
  getCapitalLog: parameter => {
    const params = Object.assign(parameter, {
      page: parameter.pageNo || 1,
      size: parameter.pageSize || 20
    })
    return axios({
      url: api.getCapitalLog,
      method: 'get',
      params: params
    }).then(res => {
      return {
        data: res.data.list || [],
        pageNo: parameter.pageNo,
        pageSize: parameter.pageSize,
        totalCount: res.data.count
      }
    })
  },
  // 获取全部待审核提现列表
  getAllToBeReviewedList: parameter => {
    const params = Object.assign(parameter, {
      page: parameter.pageNo || 1,
      size: parameter.pageSize || 20
    })
    return axios({
      url: api.getAllToBeReviewedList,
      method: 'get',
      params: params
    }).then(res => {
      return {
        data: res.data.list || [],
        pageNo: parameter.pageNo,
        pageSize: parameter.pageSize,
        totalCount: res.data.count,
        money:res.data.money
      }
    })
  },
  // 从全部待审核页面移除对应的数据
  delFromAllToBeReviewedList:(sub_id,req_id)=>{
    const params = {
      sub_id,
      req_id
    }
    return axios({
      url:api.delFromAllToBeReviewedList,
      method:'post',
      data:params
    })
  },
  /**
   * 获取提现状态
   * @param {Integer} sub_id 机器人ID
   * @param {Array} ids req_id的数组
   */
  getDrawMoneyStatus:(sub_id,ids)=>{
    const params = {
      sub_id,
      ids
    }
    return axios({
      url:api.getDrawMoneyStatus,
      method:'post',
      data:params
    })
  }
}
